// third-party
import { FormattedMessage } from 'react-intl';

// project import
import { useSelector } from 'store';

// assets
import { IconDashboard, IconDeviceAnalytics } from '@tabler/icons';

// constant
const dashboardIcon = {
    dashboard: IconDashboard,
    device: IconDeviceAnalytics
};
// ==============================|| DASHBOARD MENU ITEMS ||============================== //

export const DashboardMenu9 = () => {
    const { menuDashboard9 } = useSelector((state) => state.menu);
    const ChildrenList = menuDashboard9?.children?.map((subList) => ({
        id: subList.id,
        title: <FormattedMessage id={`${subList.title}`} />,
        type: subList.type,
        url: subList.url,
        // @ts-ignore
        icon: dashboardIcon[subList.icon],
        breadcrumbs: subList.breadcrumbs
    }));

    const dashboardList = {
        id: menuDashboard9.id,
        title: <FormattedMessage id={`${menuDashboard9.title}`} />,
        // @ts-ignore
        icon: dashboardIcon[menuDashboard9.icon],
        type: menuDashboard9.type,
        children: ChildrenList
    };

    return dashboardList;
};
